import { render, staticRenderFns } from "./ParkingOrganisation.vue?vue&type=template&id=6ed41dd4&scoped=true&"
import script from "./ParkingOrganisation.vue?vue&type=script&lang=js&"
export * from "./ParkingOrganisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed41dd4",
  null
  
)

export default component.exports